import { useContext } from 'react';
import { OptimizelyContext } from 'lib/optimizely/optimizely';
import { OptimizelyContextValue } from 'lib/optimizely/optimizely.types';

interface Result {
  isCustomInclusions: boolean;
}

const FEATURE_FLAG_NAME = 'qantas-hotels-custom-inclusions';

const useCustomInclusions = (): Result => {
  const optimizelyContext = useContext(OptimizelyContext) as OptimizelyContextValue;
  const decision = optimizelyContext?.decisions?.[FEATURE_FLAG_NAME];

  const isReady = optimizelyContext?.isReady ?? false;
  const { enabled = false } = decision || {};

  return {
    isCustomInclusions: enabled && isReady,
  };
};

export default useCustomInclusions;
